export default __webpack_public_path__ + "static/Enterprise-Integration-af65f2bc24e6f8b9275be8947a79a823.jpg";